import React from 'react';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Form from '../../Form';
import Loading from '../../Loading';

class AccountStaffResetPasswordForm extends Form {
    static propTypes = {
        onResetUserPassword: PropTypes.func,
        resetPassword: PropTypes.func,

        user: ImmutablePropTypes.map,
        status: ImmutablePropTypes.string
    };

    //todo to it just for carousel

    static fieldsValidation = {
        newPassword1: ['required', 'password-carousel', [ 'minLength' , 8]],
        newPassword2: ['required', 'password-carousel', [ 'minLength' , 8]]
    }

    static defaultProps = {
        user: Map(),
    };

    compareNewPasswords() {
        let { newPassword2, newPassword1 } = this.state.data;

        if(newPassword1 !== newPassword2){
            this.state.invalid['newPassword2'] = true;
            this.state.errors['newPassword2'] = 'Confirm Password should match New Password';

            this.setState({...this.state});

            return false
        }

        return true
    }

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);


        let isValid = Object.keys(this.state.errors).filter( x => typeof this.state.errors[x] === 'string').length === 0;
        if (isValid) {
            let valid = this.compareNewPasswords();

            if (valid) {
                let {id} = this.props.user.toJS();
                let {newPassword1} = this.state.data;
                this.props.onResetUserPassword(id, { password : newPassword1 })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(props){

        if(props.status === 'FINISHED'){
            this.props.resetPassword()
        }

        if(props.user.get('id') !== this.props.user.get('id')){
            this.state = { ...this.state, userChanged: true }
            this.props.resetPassword()
        }
    }

    renderForm() {
        let {status} = this.props;
        let isValid = Object.keys(this.state.errors).filter( x => typeof this.state.errors[x] === 'string').length === 0;

        return (
            <div className="admin-users reset-password">
                <div className="row">
                    <div className="col-12">
                        <h4>Reset password </h4>
                        {
                            this.getField(
                                <input type="password"
                                       label="New Password"
                                       { ...this.getFieldParameters('newPassword1') }
                                />
                            )
                        }
                        {
                            this.getField(
                                <input type="password"
                                       label="Confirm Password"
                                       { ...this.getFieldParameters('newPassword2') }
                                />
                            )
                        }
                    </div>
                </div>

                <div className="buttons">
                    <button className="btn btn-primary" type="submit">
                        Reset
                    </button>
                </div>

                <Loading active={ this.props.status === 'IN_PROGRESS' } />
            </div>
        )
    }
}

export default AccountStaffResetPasswordForm;
